import { ConsequenceRating } from 'src/app/models/jurisdictionRiskConfig.model';

interface ConsequenceRatingsStorage {
    ConsequenceRatings?: ConsequenceRating[];
}

const DEFAULT_CONSEQUENCE_RATING_MAX = 10;

/** Fallback 0-N consequence rating scale used when no jurisdiction config supplies one. */
export function getDefaultConsequenceRatings(): ConsequenceRating[] {
    return Array.from({ length: DEFAULT_CONSEQUENCE_RATING_MAX + 1 }, (_, i) => ({
        value: i,
        label: String(i),
        description: undefined,
    }));
}

/**
 * Parse the `ConsequenceRatings` array out of a jurisdiction/tenant `exposureLikelihoodLevels`
 * JSON blob, degrading to the default 0-10 scale when the blob is absent, malformed, or does not
 * carry a non-empty ratings array. Shared so the Risk Register bulk action and the single-entry
 * details popup resolve identical consequence rating options and cannot drift.
 */
export function parseConsequenceRatings(
    exposureLikelihoodLevelsJson: string | null | undefined,
): ConsequenceRating[] {
    if (!exposureLikelihoodLevelsJson) {
        return getDefaultConsequenceRatings();
    }

    try {
        const parsed = JSON.parse(exposureLikelihoodLevelsJson) as ConsequenceRatingsStorage;
        const ratings = parsed.ConsequenceRatings;

        if (Array.isArray(ratings) && ratings.length > 0) {
            return ratings;
        }
    } catch {
        // Malformed JSON — fall through to the default scale.
    }

    return getDefaultConsequenceRatings();
}
